const NS = 'SiteHeaderBottomSearchBarWidget';
const CLS = 'siteHeaderBottomSearchBarWidget';

export class SiteHeaderBottomSearchBarWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$input = this.$element.find(`.${CLS}-input`);
		this.$btnClose = this.$element.find(`.${CLS}-btn`);
		this.$siteHeaderBottomWidget;

		this.$element.on(`${CLS}.open`, (_event, params) => {
			this.$siteHeaderBottomWidget = params.siteHeaderBottomWidget;
			this.setDropdownPosition();
			this.$element.addClass('active');
			this.$input.val(null);
			this.$input.focus();
		});

		this.$element.on(`${CLS}.close`, () => {
			this.$element.removeClass('active');
		});

		this.$element.on(`${CLS}.updatePosition`, (_event, params) => {
			this.$siteHeaderBottomWidget = params.siteHeaderBottomWidget;
			this.setDropdownPosition();
		});

		this.$btnClose.on('click', () => {
			if(this.$siteHeaderBottomWidget && this.$siteHeaderBottomWidget.length > 0) {
				this.$siteHeaderBottomWidget.trigger('siteHeaderBottomWidget.menuWidgets.close', {});
			}
		});
	}

	setDropdownPosition() {
		this.$element.css({
			top: this.$siteHeaderBottomWidget.offset().top + this.$siteHeaderBottomWidget.height() + 1
		});
	}
}
